import React, { useContext, useEffect, useState } from 'react'
import { DateTime } from 'luxon'
import { getLanguageLocale } from 'shared'
import TransactionsContext from 'selfServicePortal/contexts/TransactionsContext'
import { useTranslation } from 'react-i18next'

interface ISelect {
	getMoreTransactionsFromMonth: Function
}

export const Select = ({ getMoreTransactionsFromMonth }: ISelect) => {
	const { t } = useTranslation()
	const { transactions } = useContext(TransactionsContext)
	const [months, setMonths] = useState<string[]>([])
	const [selectedOption, setSelectedOption] = useState<string>('')

	useEffect(() => {
		const locale = getLanguageLocale()
		const currentMonth = DateTime.now()
			.setLocale(locale)
			.toFormat('MM/yyyy')

		const getLastNMonths = (n: number) => {
			return Array.from({ length: n }, (_, index) => {
				return DateTime.now()
					.minus({ months: index })
					.setLocale(locale)
					.toFormat('MM/yyyy')
			})
		}

		const last3Months = getLastNMonths(3)

		// For FireFox and Safari compliance. Date format must be in
		// format like. yyyy/mm/dd for "new Date()"
		let safariCompliantFormat = last3Months.map(
			(date) =>
				DateTime.fromFormat(date, 'MM/yyyy').toFormat('yyyy/MM') +
				'/01',
		)
		setMonths(safariCompliantFormat)
		setSelectedOption(currentMonth)
	}, [transactions])

	const onChangeSelect = (e: any) => {
		setSelectedOption(e.target.value)
		getMoreTransactionsFromMonth(e.target.value, 10)
	}

	return (
		<select
			className="form-select"
			aria-label="Default select example"
			value={selectedOption}
			onChange={(e) => onChangeSelect(e)}>
			<option hidden>{t('SelectMonth')}</option>
			{months.map((item, key) => {
				return (
					<option key={key} value={item}>
						{DateTime.fromFormat(item, 'yyyy/MM/dd')
							.setLocale(getLanguageLocale())
							.toFormat('LLLL yyyy')}
					</option>
				)
			})}
		</select>
	)
}
export default Select
